import { render, staticRenderFns } from "./gallery-list.vue?vue&type=template&id=0a34e420&"
import script from "./gallery-list.vue?vue&type=script&lang=js&"
export * from "./gallery-list.vue?vue&type=script&lang=js&"
import style0 from "./gallery-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports